export default function replaceWithEmbed(_ref) {
  var editor = _ref.editor,
      node = _ref.node,
      text = _ref.text,
      _ref$bypassSuggestion = _ref.bypassSuggestion,
      bypassSuggestion = _ref$bypassSuggestion === void 0 ? false : _ref$bypassSuggestion,
      _ref$extractorsSelect = _ref.extractorsSelectorFilter,
      extractorsSelectorFilter = _ref$extractorsSelect === void 0 ? function () {
    return true;
  } : _ref$extractorsSelect;
  var previousNode = editor.value.document.getPreviousSibling(node.key);

  if (previousNode) {
    return editor.removeNodeByKey(node.key || editor.value.startBlock.key).command('addEmbed', text, bypassSuggestion, extractorsSelectorFilter, previousNode).moveToStartOfNode(previousNode).moveToStartOfNextBlock();
  }

  return editor.removeNodeByKey(node.key || editor.value.startBlock.key).command('addEmbed', text, bypassSuggestion, extractorsSelectorFilter).moveToStartOfNextBlock();
}